import React from 'react';
import { Card, Typography, Row, Col, Button, Empty, Tag } from 'antd';
import { GlobalOutlined, ExportOutlined } from '@ant-design/icons';
import { getPerms } from '../utils/perms';
import { visibleSites } from '../utils/companySites';

const { Title, Text } = Typography;

export default function CompanySites({ user }) {
  const isAdmin = ['admin', 'super_admin', 'manager'].includes(user?.role);
  const sites = visibleSites(isAdmin, getPerms(user));

  return (
    <div>
      <Title level={3} style={{ marginBottom: 4 }}><GlobalOutlined /> Company Sites</Title>
      <Text type="secondary">Company ki apni websites — click karo, site nayi tab me khul jayegi.</Text>

      {sites.length === 0 ? (
        <Empty style={{ marginTop: 48 }} description="Abhi aapko kisi site ka access nahi mila hai. Admin se maango." />
      ) : (
        <Row gutter={[16, 16]} style={{ marginTop: 20 }}>
          {sites.map(s => (
            <Col xs={24} sm={12} lg={8} key={s.key}>
              <Card
                hoverable
                onClick={() => window.open(s.url, '_blank', 'noopener,noreferrer')}
                style={{ borderTop: `4px solid ${s.color}`, height: '100%' }}
                styles={{ body: { padding: 20 } }}
              >
                <div style={{
                  width: 48, height: 48, borderRadius: 12, marginBottom: 12,
                  background: s.color, color: '#fff', display: 'flex',
                  alignItems: 'center', justifyContent: 'center', fontSize: 22
                }}>
                  <GlobalOutlined />
                </div>
                <Title level={4} style={{ marginBottom: 4 }}>{s.name}</Title>
                <Text type="secondary" style={{ display: 'block', minHeight: 40 }}>{s.description}</Text>
                <Tag color="default" style={{ marginTop: 8 }}>{s.url.replace('https://', '')}</Tag>
                <Button
                  type="primary"
                  icon={<ExportOutlined />}
                  block
                  style={{ marginTop: 16, background: s.color, borderColor: s.color }}
                  onClick={e => { e.stopPropagation(); window.open(s.url, '_blank', 'noopener,noreferrer'); }}
                >
                  Open {s.name}
                </Button>
              </Card>
            </Col>
          ))}
        </Row>
      )}
    </div>
  );
}
